module.exports = __webpack_public_path__ + "media/components/web/pages/sessions/resources/images/right_background-5b0066088e00181e18f26031a54c4e65.jpg";